exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardSalaryPage-5e21a .dashboardHeader-db97c{display:flex;align-items:center}.dashboardSalaryPage-5e21a .rangePicker-36f76{width:200px}", ""]);

// Exports
exports.locals = {
	"dashboardSalaryPage": "dashboardSalaryPage-5e21a",
	"dashboardHeader": "dashboardHeader-db97c",
	"rangePicker": "rangePicker-36f76"
};